import { useMemo, useCallback } from 'react';
import { DropResult } from 'react-beautiful-dnd';
import { Task } from '../types';

export const useSortedTasks = (tasks: Task[]) => {
     return useMemo(() => {
          return [...tasks].sort((a, b) => (a.taskOrder || 0) - (b.taskOrder || 0));
     }, [tasks]);
};

export const useTaskToggle = (
     selectedTasks: string[],
     onTasksChange: (tasks: string[]) => void
) => {
     return useCallback((taskName: string) => {
          const newSelectedTasks = selectedTasks.includes(taskName)
               ? selectedTasks.filter(task => task !== taskName)
               : [...selectedTasks, taskName];
          onTasksChange(newSelectedTasks);
     }, [selectedTasks, onTasksChange]);
};

export const useDragEnd = (
     selectedMilestone: string,
     onReorderTasks: ((milestoneCode: string, sourceIndex: number, destinationIndex: number) => void) | undefined,
     sortedTasks: Task[]
) => {
     return useCallback((result: DropResult) => {
          const { destination, source } = result;

          if (!destination) {
               return;
          }

          if (destination.droppableId === source.droppableId && destination.index === source.index) {
               return;
          }

          if (onReorderTasks) {
               // Find the milestone code from the first task
               const milestoneCode = sortedTasks[0]?.mileStoneCode || selectedMilestone;
               onReorderTasks(milestoneCode, source.index, destination.index);
          }
     }, [selectedMilestone, onReorderTasks, sortedTasks]);
};

export const useSaveEdit = (
     onRenameTask: ((taskId: string, newName: string) => void) | undefined
) => {
     return useCallback((taskId: string, newName: string) => {
          if (onRenameTask) {
               onRenameTask(taskId, newName);
          }
     }, [onRenameTask]);
}; 